// actions.js
import apiClient from "../../../../services/apiClient";

export const K85API = {
    getServerTime: async () => {
        try {
            const link = 'server_time';
            const response = await apiClient.get(link);

            if (response.data) {
                return { success: true, data: response.data };
            }
            
            return { success: false, error: 'No data received' };
        } catch (error) {
            console.error('Error fetching server time:', error);
            return { 
                success: false, 
                error: error.response?.data?.message || error.message 
            };
        }
    },

    getK85parts: async ({ district, period, part, t, type }) => {
        try {
            const params = new URLSearchParams();
            
            if (district) params.append('district', district);
            if (period) params.append('period', period);
            if (part) params.append('part', part.join('&part='));
            if (t) params.append('type', t);
            if (type) params.append('mode', type);

            const link = `k_85_stat?${params.toString()}`;
            const response = await apiClient.get(link);

            if (response.data) {
                return { success: true, data: response.data };
            }
            
            return { success: false, error: 'No data received' };
        } catch (error) {
            console.error('Error fetching K85 parts:', error);
            return { 
                success: false, 
                error: error.response?.data?.message || error.message 
            };
        }
    },

    getK85File: async ({ district, period, part, t, type }) => {
        try {
            const params = new URLSearchParams();
            
            if (district) params.append('district', district);
            if (period) params.append('period', period);
            if (part) params.append('part', part.join('&part='));
            if (t) params.append('type', t);
            if (type) params.append('mode', type);

            const link = `k_85_file?${params.toString()}`;
            const response = await apiClient.get(link);

            if (response.data) {
                return { success: true, data: response.data };
            }
            
            return { success: false, error: 'No data received' };
        } catch (error) {
            console.error('Error fetching K85 file:', error);
            return { 
                success: false, 
                error: error.response?.data?.message || error.message 
            };
        }
    },

    saveEditData: async (data) => {
        try {
            const link = 'k_85_stat_edit';
            const response = await apiClient.post(link, data);

            if (response.data) {
                return { success: true, data: response.data };
            }
            
            return { success: false, error: 'No data received' };
        } catch (error) {
            console.error('Error saving edit data:', error);
            return { 
                success: false, 
                error: error.response?.data?.message || error.message 
            };
        }
    },

    getInfoAboutEdit: async ({ _id, month }) => {
        try {
            const params = new URLSearchParams();
            
            if (_id) params.append('id_kg', _id);
            if (month) params.append('month', month);

            const link = `k_85_infoedit?${params.toString()}`;
            const response = await apiClient.get(link);

            if (response.data) {
                return { success: true, data: response.data };
            }
            
            return { success: false, error: 'No data received' };
        } catch (error) {
            console.error('Error fetching edit info:', error);
            return { 
                success: false, 
                error: error.response?.data?.message || error.message 
            };
        }
    }
};

export const getServerTime = async (callback, err) => {
    const result = await K85API.getServerTime();
    
    if (result.success) {
        callback(result.data);
    } else {
        err(result.error);
    }
};

export const getK85parts = async (district, period, part, t, type) => {
    return await K85API.getK85parts({ district, period, part, t, type });
};

export const getK85File = async (district, period, part, t, type) => {
    return await K85API.getK85File({ district, period, part, t, type });
};

export const getK85Props = (props) => {
    const { district, type, part } = props;
    const [cY, cM] = (new Date()).toISOString().split('T')[0].split('-');
    const [period, day] = props.period.split(' ');
    const p = ['part' + (+part+1)];
    const t = period == `${+cM}.${cY}` ? 'day' : 'month';

    return {district, period, p, t, type};
};

export const setData = async (props, callback) => {
    const {district, period, p, t, type} = getK85Props(props);
    const res_data = await getK85parts(district, period, p, t, type);
    callback(res_data.data || [], props.part, t);
};

export const saveEditData = async (data, callback_ok, callback_err) => {
    const result = await K85API.saveEditData(data);
    
    if (result.success) {
        callback_ok(result.data);
    } else {
        callback_err(result.error);
    }
};

export const getInfoAboutEdit = async (props, callback_ok, callback_err) => {
    const result = await K85API.getInfoAboutEdit(props);
    
    if (result.success) {
        callback_ok(result.data);
    } else {
        callback_err(result.error);
    }
};